import { render, staticRenderFns } from "./manage-exam-num.vue?vue&type=template&id=706cc462"
import script from "./manage-exam-num.vue?vue&type=script&lang=js"
export * from "./manage-exam-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports